import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { wizardActionCreators } from './state';
export var Wizard = /*#__PURE__*/function (_React$Component) {
  _inherits(Wizard, _React$Component);

  var _super = _createSuper(Wizard);

  function Wizard(props) {
    _classCallCheck(this, Wizard);

    return _super.call(this, props);
  }

  _createClass(Wizard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      wizardActionCreators.setNumberOfSteps(React.Children.count(this.props.children));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      wizardActionCreators.resetWizardState();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement("ul", {
        "data-test": this.props.dataTest
      }, React.Children.map(this.props.children, function (childRef, index) {
        var child = childRef;
        return React.cloneElement(child, {
          numberOfSteps: _this.props.numberOfSteps,
          activeStepIndex: _this.props.activeStepIndex,
          index: index + 1,
          dataTest: _this.props.dataTest || 'wizard'
        });
      }));
    }
  }]);

  return Wizard;
}(React.Component);